import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProductoCarta = ({ title, content, description, linkText, linkNavigation, svg, image }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    if (linkNavigation) {
      navigate(linkNavigation); // Navega dinámicamente al enlace proporcionado
    }
  };

  return (
    <div className="relative h-[25rem] w-full sm:w-[18rem] group mx-auto overflow-hidden rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 border border-zinc-700 shadow-xl transition-all duration-500 hover:border-gray-500 hover:shadow-2xl hover:shadow-gray-500/20">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-zinc-900 via-zinc-500 to-zinc-100 z-20 transition-all duration-500 group-hover:from-gray-500 group-hover:via-gray-400 group-hover:to-gray-300"></div>

      {/* Front Face */}
      <div className="absolute inset-0 flex flex-col transition-all duration-500 ease-in-out group-hover:opacity-0 group-hover:scale-95 pt-1">
        {/* Icono - Altura fija */}
        <div className="h-48 flex items-center justify-center relative p-6">
          <div className="absolute inset-0 opacity-0 transition-opacity duration-500">
            <div className="absolute inset-6 rounded-full bg-gradient-to-br from-gray-900 to-gray-500 blur-2xl"></div>
          </div>
          <div className="relative z-10 transform transition-transform duration-500">
            <div className="w-40 h-40 text-white rounded-full bg-gradient-to-br from-zinc-700 to-zinc-800 flex items-center justify-center border border-zinc-600 transition-colors duration-500 overflow-hidden">
              {image ? (
                <img src={image} alt={title} className="w-full h-full object-cover" />
              ) : (
                svg
              )}
            </div>
          </div>
        </div>

        {/* Título y Descripción - Altura fija */}
        <div className="mt-5 px-6 pb-6 flex flex-col gap-3">
          <h3 className="text-lg font-messina tracking-wider text-white text-center transition-colors duration-300 min-h-[4rem] flex items-start justify-center">
            {title}
          </h3>
          <h4 className="font-light text-zinc-300 text-center leading-relaxed text-base min-h-[4rem] flex items-start justify-center">{description}</h4>
        </div>
      </div>

      {/* Back Face */}
      <div className="absolute inset-0 flex flex-col items-center justify-around px-10 py-5 text-center text-white transition-all duration-500 ease-in-out opacity-0 translate-y-8 group-hover:opacity-100 group-hover:translate-y-0 z-10 bg-zinc-900/40 backdrop-blur-sm">
        <p className="text-lg text-left font-light text-white leading-relaxed">{content}</p>
        <div className="relative">
          <a
            onClick={handleLinkClick}
            className="text-xl text-right relative cursor-pointer inline-block text-white font-medium hover:text-zinc-300 transition-colors duration-300"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {linkText}
            <span
              className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-300 ease-in-out ${isHovered ? 'w-full' : 'w-0'
                }`}
            ></span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductoCarta;
